<script setup>
import { inject } from 'vue'

const { screen } = inject('Shared')
const links = [
  { label: 'Raumpioniere', url: 'https://raumpioniere.ch/' },
  { label: 'swisstopo', url: 'https://www.swisstopo.admin.ch/' },
  { label: 'BFE', url: 'https://www.bfe.admin.ch/' },
  { label: 'Amtliche Vermessung Schweiz / FL', url: 'https://www.cadastre.ch/' },
  { label: 'Impressum', url: 'https://www.swissenergyplanning.ch/impressum' }
]
</script>

<template lang="pug">
.linksContainer(v-if="screen.gt.xs")
  .links
    template(v-for="link in links" :key="link.label")
      a.link(:href="link.url" target="_blank") {{ link.label }}
      .linkSeparator
    a.link(href="https://www.swissenergyplanning.ch/" target="_blank") ©SEP
    a.linkText by
    a.link(href="https://www.geoimpact.ch/" target="_blank") geoimpact v.1.0.5
</template>

<style lang="sass">
.linksContainer
  background: rgba(255, 255, 255, 0.7)
  position: absolute
  z-index: 1
  padding: 0 5px
  @media screen and (min-width: 1024px)
    left: 95px
    bottom: 0px
  @media screen and (min-width: 600px) and (max-width: 1023px)
    bottom: -50px
    left: 8px
  @media screen and (max-width: 599px)
    bottom: -50px
    left: 8px
  .links
    display: flex
    flex-direction: row
    align-content: center
    flex-flow: wrap
    justify-content: center
    .linkText
      color: black
      font-size: 12px
      margin: 0 3px
    .link
      color: #0078A8
      font-size: 12px
      cursor: pointer
    .linkSeparator
      width: 2px
      height: 8px
      background: #696969
      margin: 5px
</style>
